import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import Analytics from 'utils/analytics';
import CommonValues from 'resources/common-values';

export default CreateReactClass({
    displayName: 'goal-already-set-modal',

    propTypes: {
        subject: PropTypes.instanceOf(Immutable.Map).isRequired,
    },

    getInitialState() {
        return {
            show: false,
        };
    },

    promise: null,
    resolve: null,
    reject: null,

    show() {
        this.setState({ show: true });
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });

        return this.promise;
    },

    onCancel() {
        this.reject();
        this.setState({ show: false });
    },

    onOverwrite() {
        Analytics.recordButtonClick(CommonValues.SectionIDs.growthGoals, 'update-upcoming-goal');
        this.resolve();
        this.setState({ show: false });
    },

    render() {
        const subjectBid = this.props.subject.get('bid');
        const message = [
            <p key="message-start">
                You're about to overwrite the previously entered goal for this term and subject. (Only one goal is
                allowed at a time.)
            </p>,
            <p key="message-end">Do you want to overwrite the previous goal?</p>,
        ];
        const buttons = [
            <Button
                key="cancel-button"
                id={`goal-already-set-cancel-button-${subjectBid}`}
                bsClass="cancel-button btn"
                onClick={this.onCancel}
            >
                cancel
            </Button>,
            <Button
                key="overwrite-button"
                id={`goal-already-set-overwrite-button-${subjectBid}`}
                bsClass="ok-button btn"
                onClick={this.onOverwrite}
            >
                yes, overwrite
            </Button>,
        ];

        return (
            <Modal
                id={`goal-already-set-modal-${subjectBid}`}
                bsSize="lg"
                aria-labelledby="goal-already-set"
                onHide={this.onCancel}
                bsClass="growth-goal-modal modal"
                show={this.state.show}
            >
                <Modal.Header key="header" closeButton={true}>
                    <Modal.Title>Goal Already Set</Modal.Title>
                </Modal.Header>
                <Modal.Body key="body">{message}</Modal.Body>
                <Modal.Footer>{buttons}</Modal.Footer>
            </Modal>
        );
    },
});
